<template>
  <v-container>
    <v-layout align-center justify-center>
      <v-card mx-auto :loading="isLoading">
        <form @submit.prevent="login">
          <v-card-title primary-title>
          <div>
            <div class="headline">เข้าสู่ระบบ</div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-text-field
            name="email"
            label="E-mail"
            aria-autocomplete="email"
            v-model="input.email"
          ></v-text-field>
          <v-text-field
            name="password"
            label="Password"
            type="password"
            v-model="input.password"
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" type="submit">เข้าสู่ระบบ</v-btn>
        </v-card-actions>
        </form>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      input: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    login() {
      this.isLoading = true;
      this.$store
        .dispatch("signIn", this.input)
        .then(() => {
          this.$router.push('/home')
        })
        .catch(reason => {
          this.$store.commit("showSnackbar", {text: reason.message})
        })
        .finally(() => {
          this.isLoading = false;
        })
    }
  }
};
</script>